import { Component, OnInit } from '@angular/core';
import { CentralService } from '../servicios/central.service';

@Component({
  selector: 'app-acercade',
  templateUrl: './acercade.component.html',
  styleUrls: ['./acercade.component.css']
})
export class acercadeComponent implements OnInit {
  fecdia: string;
  nomusu: string;

  constructor(private srvCentral: CentralService) {}

  ngOnInit(): void {
    this.fecdia = new Date().toLocaleString(); 
    this.nomusu = this.srvCentral.datosIden.UsuNom;
  }
}